<template lang="pug">
	.input-btn-wrapper(v-if="ready" :class="{'error': error}")
		label
			span.input-wrapper
				span.label(v-if="label")
					| {{label}}
				slot
			span.start-btn(@click="emitClick($event)" :class="{'loading': loading}")
				span.spinner(v-if="loading")
					spinner(size="20")
				span(v-else)
					| {{btnText}}
					span.arrow-right
		span.error(v-show="error")
			| {{errorMessage}}
</template>

<style lang="stylus" scoped>
	@import '~assets/css/variables.styl'

	.input-btn-wrapper
		.error
			color: chart-red
			margin-top: 5px
			display: block
			transition-all()
			font-size: body-font-size-xs
		&.error
			label
				.start-btn
				.input-wrapper
					border-color: chart-red
		label
			box-shadow-dd()
			max-width: 350px
			background-color: #fff
			border-radius()
			position: relative
			padding: 0
			font-weight: body-font-weight
			font-size: body-font-size-xxs
			text-align: left
			color: sfc-gray-dark
			margin: 0 auto
			cursor: pointer
			display: flex
			.input-wrapper
				width: 70%
				position: relative
				border: 1px solid sfc-pale-gray
				transition-all-four()
				border-right: 0px solid transparent
				border-left-radius()
				.label
					text-align: left
					width: calc(100% - 10px)
					clear: both
					font-weight: body-font-weight
					display: block
					margin: 7px 0 0 10px
				select
				input
					position: absolute
					width: 100%
					height: 100%
					top: 0
					input-appearance-none()
					box-shadow-none()
					border-radius(none)
					width: 100%
					clear: both
					display: block
					font-size: body-font-size-md
					padding: 15px 0 0 10px
					color: body-font-color
					background: transparent
					border: 0px solid transparent
			.start-btn
				background: sfc-blue-link
				color: #fff
				text-align: center
				width: 100%
				border: 1px solid sfc-blue-link
				border-left: 0px solid transparent
				padding: 15px 15px 15px 0
				width: 30%
				font-size: body-font-size-md
				font-weight: body-font-weight
				text-transform: uppercase
				border-right-radius()
				transition-all()
				.arrow-right
					position: absolute
					border-left-color: #fff
				&:hover
					border: 1px solid sfc-blue
					border-left: 0px solid transparent
				&.loading
					padding-left: 15px
			&:hover
			&:focus
				.input-wrapper
					border: 1px solid sfc-blue-link
					border-right: 0px solid transparent

					


</style>
<script>
import Spinner from 'vue-simple-spinner/src/components/Spinner.vue'

export default {
	components: {
		Spinner
	},
	props: {
		errorMessage:{
			default: false
		},
		error:{
			default: false
		},
		value:{
			default: null
		},
		label:{
			default: null
		},
		btnText:{
			default: "Start"
		},
		loading:{
			default: false
		}
	},
	data() {
		return {
			ready: false
		}

	},
	mounted(){
		this.ready = true

	},
	methods:{
		emitClick(event){
			this.$emit('click', event)
		}
	}
}
</script>
